import type { RouteObject } from 'react-router-dom'
import Layout from '@/components/Layout'
import StylesProvider from '@/components/StylesProvider'
import Home from '@/pages/Home'
import Adultes from '@/pages/Adultes'
import Institutions from '@/pages/Institutions'
import APropos from '@/pages/APropos'
import Contact from '@/pages/Contact'
import AdminStyles from '@/pages/AdminStyles'
import { useRoutes } from 'react-router-dom'

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: '/', element: <Home /> },
      { path: '/adultes', element: <Adultes /> },
      { path: '/institutions', element: <Institutions /> },
      { path: '/a-propos', element: <APropos /> },
      { path: '/contact', element: <Contact /> },
    ],
  },
  // Admin routes — no Layout (no public nav/footer)
  { path: '/admin', element: <AdminStyles /> },
  { path: '/admin/styles', element: <AdminStyles /> },
]

function App() {
  const element = useRoutes(routes)
  return (
    <>
      <StylesProvider />
      {element}
    </>
  )
}

export default App
